import React from "react";
import cx from "classnames";
import type { ProcessedRacingEvent } from "@/hooks/firestore/v2/betting/useRacingEvents";
import { MoreInfo } from "@/components/MoreInfo";
import { EventStatus, type StatusEnum } from "@/components/layout/EventStatus";
import { useIsLoggedIn } from "@/hooks/useIsLoggedIn";
import { SmallPromoIcon } from "@/components/PromoIcon/SmallPromoIcon";
import { Row } from "@/features/racing/components/Row";
import { toTitleCaseWithExclusions } from "@/utilities/racingUtilities";

import { raceNumber, largeIcon } from "./Row.module.scss";

type MeetingRaceRowProps = {
  event: ProcessedRacingEvent;
};

const MeetingRaceRow = ({ event }: MeetingRaceRowProps) => {
  const isLoggedIn = useIsLoggedIn();

  const results = Object.values(event.results).join("  |  ");

  return (
    <Row
      isComplete={[
        "CANCELLED",
        "CLOSED",
        "FINAL",
        "ABANDONED",
        "DONE",
        "INTERIM",
      ].includes(event.status)}
      to={`/racing/betting/race/${event.meetingId}/${event.id}`}
      icon={
        <>
          <div className={raceNumber}>R{event.number}</div>
          {isLoggedIn && event.showPromoBanner ? <SmallPromoIcon /> : null}
        </>
      }
      header={toTitleCaseWithExclusions(event.name)}
      subHeader={results || event.distance}
      iconClassName={largeIcon}
      clamp={
        <>
          <EventStatus
            status={event.status as unknown as StatusEnum} // TODO: need to fix status enum to receive values from racing and betting event statuses
            scheduledStartTime={event.scheduledStartTime}
          />
          <MoreInfo direction="horizontal" />
        </>
      }
    />
  );
};

export { MeetingRaceRow };
